import { render } from "./WhyPartner.vue?vue&type=template&id=eeda6000&scoped=true"
import script from "./WhyPartner.vue?vue&type=script&lang=js"
export * from "./WhyPartner.vue?vue&type=script&lang=js"

import "./WhyPartner.vue?vue&type=style&index=0&id=eeda6000&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eeda6000"]])

export default __exports__